// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"de20d31a","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"526e6cf4","726":"edb9bd39"}[chunkId] + ".chunk.js";
};